<div class="card">
  <h5 class="text-blue-700">Cliente</h5>

  <p-fieldset legend="Dados cadastrais">
    <div class="formgrid grid p-fluid">
      <div class="field col-6">
        <label for="razaoSocial">Razão Social: </label>
        <input
          type="text"
          id="razaoSocial"
          pInputText
          [(ngModel)]="cliente.razaoSocial"
          required
        />
      </div>
      <div class="field col-6">
        <label for="cnpj">CNPJ: </label>
        <p-inputMask
          id="cnpj"
          mask="99.999.999/9999-99"
          [(ngModel)]="cliente.cnpj"
          placeholder="00.000.000/0000-00"
        ></p-inputMask>
      </div>
      <div class="field col-8">
        <label for="logradouro">Logradouro: </label>
        <input
          type="text"
          id="logradouro"
          pInputText
          [(ngModel)]="cliente.logradouro"
          required
        />
      </div>
      <div class="field col-4">
        <label for="numero">Número: </label>
        <input
          type="text"
          id="numero"
          pInputText
          [(ngModel)]="cliente.numero"
          required
        />
      </div>
      <div class="field col-4">
        <label for="complemento">Complemento: </label>
        <input
          type="text"
          id="complemento"
          pInputText
          [(ngModel)]="cliente.complemento"
          required
        />
      </div>
      <div class="field col-2">
        <label for="bairro">Bairro: </label>
        <input
          type="text"
          id="bairro"
          pInputText
          [(ngModel)]="cliente.bairro"
          required
        />
      </div>
      <div class="field col-2">
        <label for="cep">CEP: </label>
        <p-inputMask
          id="cep"
          mask="99999-999"
          [(ngModel)]="cliente.cep"
          placeholder="99999-999"
        ></p-inputMask>
      </div>
      <div class="field col-3">
        <label for="municipio">Municipio: </label>
        <input
          type="text"
          id="municipio"
          pInputText
          [(ngModel)]="cliente.municipio"
          required
        />
      </div>
      <div class="field col-1">
        <label for="uf">UF: </label>
        <input
          type="text"
          id="uf"
          pInputText
          [(ngModel)]="cliente.uf"
          required
        />
      </div>
      <div class="field col-3">
        <label for="email">E-mail: </label>
        <input
          type="email"
          id="email"
          pInputText
          [(ngModel)]="cliente.email"
          required
        />
      </div>
      <div class="field col-2">
        <label for="fone">Telefone: </label>
        <p-inputMask
          id="fone"
          mask="(99) 99999-9999"
          [(ngModel)]="cliente.fone"
          placeholder="(99) 99999-9999"
        ></p-inputMask>
      </div>
      <div class="field col-5"></div>
      <div class="field col-2 pt-4">
        <button
          pButton
          icon="pi pi-save"
          class="p-button-success"
          [label]="cliente.id ? 'Atualizar' : 'Salvar'"
          (click)="salvar()"
        ></button>
      </div>
    </div>
  </p-fieldset>

  <div class="mt-3">
    <p-fieldset legend="Ambientes">
      <button
        pButton
        icon="pi pi-plus"
        label="Novo ambiente"
        (click)="abreNovoDialog()"
        [disabled]="!cliente.id"
      ></button>

      <div class="mt-3">
        <p-table
          [value]="cliente.ambientes"
          editMode="row"
          class="pb-5"
          [scrollable]="true"
          scrollHeight="400px"
          [tableStyle]="{ 'min-width': '50rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Nome</th>
              <th>Base</th>
              <th>URL PIMS</th>
              <th>URL ERP</th>
              <th>Produção</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-ambiente
            let-editing="editing"
            let-ri="rowIndex"
          >
            <tr pEditableRow="ambiente">
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="ambiente.ambiente"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ ambiente.ambiente }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [style]="{ width: '100%' }"
                      appendTo="body"
                      [options]="cliente.bases"
                      optionValue="id"
                      optionLabel="nome"
                      [(ngModel)]="ambiente.baseId"
                      dataKey="id"
                      inputId="id"
                      placeholder="Selecione uma base"
                    ></p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ ambiente.baseNome }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="ambiente.urlApiPims"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ ambiente.urlApiPims }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="ambiente.urlApiErp"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ ambiente.urlApiErp }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-checkbox
                      id="produtivo"
                      [(ngModel)]="ambiente.produtivo"
                      [binary]="true"
                    ></p-checkbox>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <p-checkbox
                      id="produtivo"
                      [(ngModel)]="ambiente.produtivo"
                      [binary]="true"
                      [disabled]="true"
                    ></p-checkbox>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-button
                  *ngIf="!editing && ambiente.ativo"
                  icon="pi pi-pencil"
                  [rounded]="true"
                  pInitEditableRow
                  [text]="true"
                  severity="info"
                  (click)="editarAmbiente(ambiente)"
                  aria-label="Editar"
                ></p-button>

                <p-button
                  *ngIf="editing"
                  icon="pi pi-check"
                  [rounded]="true"
                  pSaveEditableRow
                  [text]="true"
                  severity="info"
                  (click)="atualizarAmbiente(ambiente)"
                  aria-label="Salvar"
                ></p-button>
                <p-button
                  *ngIf="editing"
                  icon="pi pi-times"
                  [rounded]="true"
                  pCancelEditableRow
                  [text]="true"
                  severity="danger"
                  (click)="cancelarAmbiente(ambiente, ri)"
                  aria-label="Cancelar"
                ></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-fieldset>
  </div>
  <app-novo-ambiente-dialog
    [visivel]="abreNovoAmbiente"
    (fechar)="escondeNovoDialog()"
    [bases]="cliente.bases"
    [cliente]="cliente.id"
  ></app-novo-ambiente-dialog>

  <app-usuario
    [visivel]="abreUsuarioDialog"
    (fechar)="escondeUsuarioDialog()"
    [cliente]="cliente.id"
    [perfis]="cliente.perfis"
  >
  </app-usuario>

  <div class="mt-3">
    <p-fieldset legend="Usuários">
      <button
        pButton
        icon="pi pi-plus"
        label="Novo Usuário"
        (click)="abreUsuario()"
        [disabled]="!cliente.id"
      ></button>
      <div class="mt-3">
        <p-table [value]="cliente.usuarios" class="pb-5" [scrollable]="true" editMode="row">
          <ng-template pTemplate="header">
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Usuário ERP</th>
              <th>Perfil</th>
              <th>Ativo</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-usuario
            let-editing="editing"
            let-ri="rowIndex"
          >
            <tr pEditableRow="usuario">
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="usuario.nomeUsuario"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ usuario.nomeUsuario }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="usuario.email"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ usuario.email }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="usuario.cdUsuarioErp"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ usuario.cdUsuarioErp }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown [style]="{'width':'100%'}" appendTo="body" [options]="cliente.perfis" optionValue="id" optionLabel="nomePerfil" [(ngModel)]="usuario.perfilId" dataKey="id" inputId="id" placeholder="Selecione um perfil" emptyMessage="Nenhum perfil disponivel"></p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ usuario.perfilNomePerfil }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-tag [value]="usuario.ativo ? 'Ativo' : 'Inativo'" [severity]="usuario.ativo ? 'success' : 'danger'"></p-tag>
              </td>
              <td>
                <p-button
                  *ngIf="!editing && usuario.ativo"
                  icon="pi pi-pencil"
                  [rounded]="true"
                  pInitEditableRow
                  [text]="true"
                  severity="info"
                  (click)="editarUsuario(usuario)"
                  aria-label="Editar"
                ></p-button>
                <p-button
                  *ngIf="!editing && usuario.ativo"
                  icon="pi pi-ban"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (click)="desativarUsuario(usuario)"
                  aria-label="Desativar"
                ></p-button>
                <p-button
                  *ngIf="!editing && !usuario.ativo"
                  icon="pi pi-check"
                  [rounded]="true"
                  [text]="true"
                  severity="success"
                  (click)="ativarUsuario(usuario)"
                  aria-label="Ativar"
                ></p-button>

                <p-button
                  *ngIf="editing"
                  icon="pi pi-check"
                  [rounded]="true"
                  pSaveEditableRow
                  [text]="true"
                  severity="info"
                  (click)="atualizarUsuario(usuario)"
                  aria-label="Salvar"
                ></p-button>
                <p-button
                  *ngIf="editing"
                  icon="pi pi-times"
                  [rounded]="true"
                  pCancelEditableRow
                  [text]="true"
                  severity="danger"
                  (click)="cancelarUsuario(usuario, ri)"
                  aria-label="Cancelar"
                ></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-fieldset>
  </div>

  <div class="mt-3">
    <p-fieldset legend="Perfis">
      <a [routerLink]="['/', 'administracao', 'perfil', 'novo']" [queryParams]="{ cliente: cliente.id }"><button
        pButton
        icon="pi pi-plus"
        label="Novo Perfil"
        
        [disabled]="!cliente.id"
      ></button></a>
      <div class="mt-3">
        <p-table [value]="cliente.perfis" class="pb-5" [scrollable]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>Nome</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-perfil
          >
            <tr>
              <td>
                {{ perfil.nomePerfil }}
              </td>
              
              <td>
                <a [routerLink]="['/', 'administracao', 'perfil', 'editar', perfil.id]"><p-button
                  icon="pi pi-pencil"
                  [rounded]="true"
                  [text]="true"
                  severity="info"
                  aria-label="Editar"
                ></p-button></a>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-fieldset>
  </div>
</div>
